import ChangePaymentMethodModal from 'components/ChangePaymentMethodModal';
import RenderPaymentMethod from 'components/RenderPaymentMethod';
import React, { useState } from 'react';
import styles from './index.module.scss';

const CartPaymentMethod = (props) => {
  const {
    quoteCartFn,
    details: { paymentMethod = {}, status = '' } = {},
    user: { objectId: userId = '' } = {},
  } = props;
  const [changePaymentMethodModalOpen, setChangePaymentMethodModalOpen] = useState(false);

  const onChangePaymentMethod = async (paymentMethod) => {
    quoteCartFn({ selectedPaymentMethodId: paymentMethod });
  };

  const isPaymentMethodSelected = !!paymentMethod?.id;

  const getPaymentMethod = () => {
    if (isPaymentMethodSelected) {
      return <RenderPaymentMethod paymentMethod={paymentMethod} />; 
    } else {
      return <div>
        No Payment Method is selected
      </div>;
    }
  };

  const toggleModal = () => {
    setChangePaymentMethodModalOpen(!changePaymentMethodModalOpen);
  };

  const getPaymentMethodSelector = () => {
    if(status !== 'ACTIVE') return null;
    return (
      <div className={styles['select-payment-method']} onClick={()=>{
        setChangePaymentMethodModalOpen(true);
      }}>{isPaymentMethodSelected ? 'Change' : 'Select'}</div>
    );
  };

  return (
    <>
      {changePaymentMethodModalOpen && <ChangePaymentMethodModal
        userId={userId}
        toggleModal={toggleModal}
        title="Payment Method"
        onPaymentMethodChange={onChangePaymentMethod}
      />}
      {getPaymentMethod()}
      {getPaymentMethodSelector()}
    </>
  );
};

export default CartPaymentMethod;

